/**
 * PageFly Shop All filters: flavour (custom.flavour_filter) and/or wellness goals
 * (custom.wellness_goals_filter). Combined with AND logic when both sections exist.
 * No “All” control: click an active chip/card again to clear that filter.
 */
(function () {
  'use strict';

  if (window.__NB_SHOP_ALL_PF_FILTERS__) return;
  window.__NB_SHOP_ALL_PF_FILTERS__ = true;

  var UNIFIED_GRID_SEL = '.nb-pf-filter__unified-grid[data-nb-pf-unified-grid]';
  var UNIFIED_SLIDE_HOST_CLASS = 'nb-pf-filter--unified-slide-host';
  var SECTION_REPOSITION_ATTR = 'data-nb-pf-filter-section-placed';

  var flavourSelected = '__all__';
  var wellnessSelected = '__all__';

  function filterSectionRoots() {
    return Array.prototype.slice.call(
      document.querySelectorAll(
        '.nb-shop-all-flavour-filter, .nb-shop-all-wellness-filter'
      )
    );
  }

  function parseJsonMap(id) {
    var el = document.getElementById(id);
    if (!el || !el.textContent) return {};
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return {};
    }
  }

    function sliderExcludedFromShopAllFilter(slider) {
    if (!slider || typeof slider.closest !== 'function') return false;
    if (slider.closest('[data-nb-pf-filter-exclude]')) return true;
    if (slider.closest('[data-pf-type="GlobalSection"]')) return true;
    if (slider.closest('[data-section-id="pf-d7cb"]')) return true;
    return false;
  }
  function productSliders() {
    return Array.prototype.slice
      .call(document.querySelectorAll('.pf-slider'))
      .filter(function (slider) {
        if (slider.classList.contains(UNIFIED_SLIDE_HOST_CLASS)) return false;
                if (sliderExcludedFromShopAllFilter(slider)) return false;
        return (
          slider.querySelector('.pf-slide a[href*="/products/"]') ||
          slider.querySelector('.pf-slide img[data-href*="/products/"]')
        );
      });
  }

  function handleFromSlide(slide) {
    var img = slide.querySelector('img[data-href*="/products/"]');
    if (img) {
      var u = img.getAttribute('data-href');
      var m = u && u.match(/\/products\/([^/?#]+)/);
      if (m) return decodeURIComponent(m[1]);
    }
    var a = slide.querySelector('a[href*="/products/"]');
    if (a) {
      var h = a.getAttribute('href');
      var m2 = h && h.match(/\/products\/([^/?#]+)/);
      if (m2) return decodeURIComponent(m2[1]);
    }
    return null;
  }

  function bandRowForSlider(slider) {
    var el = slider.parentElement;
    while (el) {
      if (
        el.getAttribute &&
        el.getAttribute('data-pf-type') === 'Row' &&
        el.parentElement &&
        el.parentElement.classList &&
        el.parentElement.classList.contains('ejtSSi')
      ) {
        return el;
      }
      el = el.parentElement;
    }
    return null;
  }

  function visibleSlideCountInSlider(slider) {
    var slides = slider.querySelectorAll(':scope > .pf-slide');
    var n = 0;
    for (var i = 0; i < slides.length; i++) {
      if (!slides[i].classList.contains('nb-pf-filter--hidden')) {
        n++;
      }
    }
    return n;
  }

  function matchesDimension(slide, selected, byHandle, dimensionActive) {
    if (!dimensionActive || selected === '__all__') return true;
    var handle = handleFromSlide(slide);
    var vals = handle != null ? byHandle[handle] : undefined;
    if (
      !handle ||
      !Object.prototype.hasOwnProperty.call(byHandle, handle)
    ) {
      return false;
    }
    if (!vals || vals.length === 0) return false;
    return vals.indexOf(selected) !== -1;
  }

  function slideShouldShow(
    slide,
    flavourByHandle,
    wellnessByHandle,
    hasFlavour,
    hasWellness
  ) {
    return (
      matchesDimension(
        slide,
        flavourSelected,
        flavourByHandle,
        hasFlavour
      ) &&
      matchesDimension(
        slide,
        wellnessSelected,
        wellnessByHandle,
        hasWellness
      )
    );
  }

  function applySlideVisibility(
    slide,
    flavourByHandle,
    wellnessByHandle,
    hasFlavour,
    hasWellness
  ) {
    var show = slideShouldShow(
      slide,
      flavourByHandle,
      wellnessByHandle,
      hasFlavour,
      hasWellness
    );
    slide.classList.toggle('nb-pf-filter--hidden', !show);
    if (!show) {
      slide.style.display = 'none';
    } else {
      slide.style.removeProperty('display');
    }
  }

  function dedupeKeyFromHandle(handle) {
    if (handle == null || handle === '') return null;
    return String(handle).toLowerCase();
  }

  function clearDuplicateMarks(sliders, sliderSlideOrder) {
    sliders.forEach(function (slider) {
      var list = sliderSlideOrder.get(slider);
      if (!list) return;
      list.forEach(function (slide) {
        slide.classList.remove('nb-pf-filter--dup');
      });
    });
  }

  function markDuplicateVisibleSlides(sliders, sliderSlideOrder) {
    var seen = Object.create(null);
    sliders.forEach(function (slider) {
      var order = sliderSlideOrder.get(slider);
      if (!order) return;
      order.forEach(function (slide) {
        if (slide.classList.contains('nb-pf-filter--hidden')) return;
        var h = handleFromSlide(slide);
        var key = dedupeKeyFromHandle(h);
        if (key == null) return;
        if (seen[key]) {
          slide.classList.add('nb-pf-filter--dup');
          slide.style.display = 'none';
          return;
        }
        seen[key] = true;
      });
    });
  }

  function clearStripDecorOnSliders(sliders) {
    sliders.forEach(function (slider) {
      var row = bandRowForSlider(slider);
      if (row) row.classList.remove('nb-flavour-filter--strip-decor');
      slider.classList.remove('nb-flavour-filter--expand-cols');
    });
  }

  function restoreSlidesToSliders(sliders, sliderSlideOrder) {
    sliders.forEach(function (slider) {
      var slides = sliderSlideOrder.get(slider);
      if (!slides || !slides.length) return;
      var anchor = slider.querySelector(
        ':scope > .pf-slider-prev, :scope > .pf-slider-next, :scope > .pf-slider-nav'
      );
      slides.forEach(function (slide) {
        var p = slide.parentElement;
        var host =
          p &&
          p.classList &&
          p.classList.contains(UNIFIED_SLIDE_HOST_CLASS)
            ? p
            : null;
        slider.insertBefore(slide, anchor || null);
        if (host) host.remove();
      });
    });
  }

  function removeUnifiedGrid() {
    var g = document.querySelector(UNIFIED_GRID_SEL);
    if (g) g.remove();
  }

  function anchorAfterPf48fe(sliders) {
    var scopes = [];
    var main = document.getElementById('MainContent');
    if (main) scopes.push(main);
    var byId = document.getElementById('__pf');
    if (byId) scopes.push(byId);
    if (sliders && sliders.length) {
      var n = sliders[0];
      while (n) {
        if (n.id === '__pf') {
          scopes.push(n);
          break;
        }
        n = n.parentElement;
      }
    }
    var sel = '[data-section-id="pf-48fe"]';
    for (var i = 0; i < scopes.length; i++) {
      var hit = scopes[i].querySelector(sel);
      if (hit) return hit;
    }
    return document.querySelector(sel);
  }

  function repositionFilterSections(sliders) {
    var anchor = anchorAfterPf48fe(sliders);
    if (!anchor || !anchor.parentNode) return;
    var roots = filterSectionRoots();
    roots.forEach(function (root) {
      var sectionEl = root.closest('.shopify-section') || root.closest('section');
      if (!sectionEl || sectionEl.hasAttribute(SECTION_REPOSITION_ATTR)) return;
      if (sectionEl.contains(anchor)) return;
      if (anchor.nextElementSibling === sectionEl) {
        sectionEl.setAttribute(SECTION_REPOSITION_ATTR, '');
        anchor = sectionEl;
        return;
      }
      anchor.insertAdjacentElement('afterend', sectionEl);
      sectionEl.setAttribute(SECTION_REPOSITION_ATTR, '');
      anchor = sectionEl;
    });
  }

  function lastFilterSectionElement() {
    var roots = filterSectionRoots();
    if (!roots.length) return null;
    var lastRoot = roots[roots.length - 1];
    return lastRoot.closest('.shopify-section') || lastRoot.closest('section');
  }

  function createUnifiedGrid() {
    var section = lastFilterSectionElement();
    var grid = document.createElement('div');
    grid.className = 'nb-pf-filter__unified-grid';
    grid.setAttribute('data-nb-pf-unified-grid', '');
    grid.setAttribute('role', 'region');
    grid.setAttribute('aria-label', 'Filtered products');
    if (section && section.parentNode) {
      section.insertAdjacentElement('afterend', grid);
    } else {
      return null;
    }
    return grid;
  }

  function resetSliderToCarousel(slider) {
    slider.classList.remove('nb-pf-filter--filtered');
    slider.scrollLeft = 0;
  }

  function updateBandRows(
    sliders,
    flavourByHandle,
    wellnessByHandle,
    hasFlavour,
    hasWellness,
    unifiedActive
  ) {
    var byRow = new Map();
    sliders.forEach(function (slider) {
      var row = bandRowForSlider(slider);
      if (!row) return;
      var add = unifiedActive ? 0 : visibleSlideCountInSlider(slider);
      byRow.set(row, (byRow.get(row) || 0) + add);
    });

    var neither =
      (!hasFlavour || flavourSelected === '__all__') &&
      (!hasWellness || wellnessSelected === '__all__');

    byRow.forEach(function (total, row) {
      if (neither) {
        row.classList.remove('nb-pf-filter--band-empty');
      } else if (total === 0) {
        row.classList.add('nb-pf-filter--band-empty');
      } else {
        row.classList.remove('nb-pf-filter--band-empty');
      }
    });
  }

  function syncFlavourUI(flavourRoot) {
    if (!flavourRoot) return;
    flavourRoot.querySelectorAll('[data-nb-flavour]').forEach(function (b) {
      var active = b.getAttribute('data-nb-flavour') === flavourSelected;
      b.classList.toggle('is-active', active);
      b.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function syncWellnessUI(wellnessRoot) {
    if (!wellnessRoot) return;
    wellnessRoot.querySelectorAll('[data-nb-wellness]').forEach(function (b) {
      var active = b.getAttribute('data-nb-wellness') === wellnessSelected;
      b.classList.toggle('is-active', active);
      b.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function init() {
    var flavourRoot = document.querySelector('.nb-shop-all-flavour-filter');
    var wellnessRoot = document.querySelector('.nb-shop-all-wellness-filter');
    if (!flavourRoot && !wellnessRoot) return;

    var hasFlavour = !!flavourRoot;
    var hasWellness = !!wellnessRoot;
    var flavourByHandle = hasFlavour
      ? parseJsonMap('nb-flavour-filter-data')
      : {};
    var wellnessByHandle = hasWellness
      ? parseJsonMap('nb-wellness-filter-data')
      : {};

    var sliders = productSliders();
    if (!sliders.length) return;

    var sliderSlideOrder = new Map();
    sliders.forEach(function (s) {
      sliderSlideOrder.set(
        s,
        Array.prototype.slice.call(s.querySelectorAll(':scope > .pf-slide'))
      );
    });

    repositionFilterSections(sliders);

    function applyFilters() {
      var unified =
        (hasFlavour && flavourSelected !== '__all__') ||
        (hasWellness && wellnessSelected !== '__all__');

      clearDuplicateMarks(sliders, sliderSlideOrder);

      if (unified) {
        document.body.classList.add('nb-pf-filter--unified');
        restoreSlidesToSliders(sliders, sliderSlideOrder);
        removeUnifiedGrid();
        clearStripDecorOnSliders(sliders);

        sliders.forEach(function (s) {
          resetSliderToCarousel(s);
          var slides = sliderSlideOrder.get(s);
          if (!slides) return;
          slides.forEach(function (slide) {
            applySlideVisibility(
              slide,
              flavourByHandle,
              wellnessByHandle,
              hasFlavour,
              hasWellness
            );
          });
        });

        markDuplicateVisibleSlides(sliders, sliderSlideOrder);

        var grid = createUnifiedGrid();
        if (grid) {
          sliders.forEach(function (slider) {
            var order = sliderSlideOrder.get(slider);
            if (!order) return;
            order.forEach(function (slide) {
              slide.style.removeProperty('width');
              slide.style.removeProperty('min-width');
              slide.style.removeProperty('max-width');
              slide.style.removeProperty('flex');
              slide.style.removeProperty('flex-basis');
              var host = document.createElement('div');
              host.className = UNIFIED_SLIDE_HOST_CLASS;
              host.appendChild(slide);
              grid.appendChild(host);
            });
          });
        }

        updateBandRows(
          sliders,
          flavourByHandle,
          wellnessByHandle,
          hasFlavour,
          hasWellness,
          true
        );
      } else {
        document.body.classList.remove('nb-pf-filter--unified');
        restoreSlidesToSliders(sliders, sliderSlideOrder);
        removeUnifiedGrid();
        clearStripDecorOnSliders(sliders);

        sliders.forEach(function (s) {
          var slides = sliderSlideOrder.get(s);
          if (!slides) return;
          slides.forEach(function (slide) {
            slide.classList.remove('nb-pf-filter--dup');
            applySlideVisibility(
              slide,
              flavourByHandle,
              wellnessByHandle,
              hasFlavour,
              hasWellness
            );
          });
          resetSliderToCarousel(s);
        });

        updateBandRows(
          sliders,
          flavourByHandle,
          wellnessByHandle,
          hasFlavour,
          hasWellness,
          false
        );
      }

      syncFlavourUI(flavourRoot);
      syncWellnessUI(wellnessRoot);

      window.requestAnimationFrame(function () {
        sliders.forEach(function (s) {
          s.scrollLeft = 0;
        });
      });
    }

    if (flavourRoot) {
      flavourRoot.querySelectorAll('[data-nb-flavour]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var v = btn.getAttribute('data-nb-flavour');
          if (!v) return;
          flavourSelected =
            flavourSelected === v ? '__all__' : v;
          applyFilters();
        });
      });
    }

    if (wellnessRoot) {
      wellnessRoot.querySelectorAll('[data-nb-wellness]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var v = btn.getAttribute('data-nb-wellness');
          if (!v) return;
          wellnessSelected =
            wellnessSelected === v ? '__all__' : v;
          applyFilters();
        });
      });
    }

    applyFilters();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
